import React from "react";
import "./style.css";
import ContactSpin from "../SpinMasterPrivacyPolicy/ContactSpin";

const ImageToPdfPrivacyPolicy = () => {
  return (
    <div className="imageToPdfPrivacyPolicyBody">
      <main className="imageToPdfPrivacyPolicyMain">
        <h1>Privacy Policy for Image to PDF PDF Reader</h1>
        <p>Last Updated: March 03, 2026</p>
        <p>
          Welcome to Image to PDF PDF Reader (the "Application"). This Privacy
          Policy explains how we ("we," "our," or "us") collect, use, disclose,
          and safeguard your information when you use our Application. Our
          primary goal is to provide a secure, on-device file conversion
          experience.
        </p>

        <h2>1. Images, PDFs & Local Processing</h2>
        <p>
          Our Application allows you to convert images to PDFs, scan documents,
          compress, merge, and split PDF files. How we handle your files:
        </p>
        <ul>
          <li>
            <strong>100% Local Processing:</strong> All image-to-PDF
            conversions, document scanning, and PDF modifications happen
            entirely locally on your device.
          </li>
          <li>
            <strong>No Cloud Uploads:</strong> We absolutely do NOT collect,
            store, upload, or transmit any of your images, photos, or generated
            PDF files to our servers or any third-party servers.
          </li>
          <li>
            <strong>Data Privacy:</strong> Your personal files remain solely on
            your device and are completely private to you.
          </li>
        </ul>

        <h2>2. Device Permissions Required</h2>
        <p>
          To provide its core functionality, our Application requires the
          following permissions. These are strictly used for the app's features
          and not for unauthorized data collection:
        </p>
        <ul>
          <li>
            <strong>Storage / Photos and Media Permission:</strong> Required to
            allow you to select existing images from your gallery to convert to
            PDF, and to save the generated PDF files back to your device
            storage.
          </li>
          <li>
            <strong>Camera Permission:</strong> Required for the "Smart Scan"
            and "Camera" features, allowing you to take new photos directly
            within the app to immediately convert them into PDF documents.
          </li>
        </ul>

        <h2>3. Information Collected Automatically</h2>
        <p>
          While we do not collect your personal files, we do collect certain
          technical and usage information to maintain and improve the
          Application:
        </p>
        <ul>
          <li>
            <strong>Device Information:</strong> Includes your device model,
            operating system version, screen resolution, and application
            version.
          </li>
          <li>
            <strong>Usage Data / Analytics:</strong> We track user interactions
            (e.g., which features are used most often) and crash reports to
            identify bugs and improve app stability.
          </li>
          <li>
            <strong>Advertising IDs:</strong> Identifiers such as Google
            Advertising ID (GAID) are used to support ad personalization and
            measure ad performance.
          </li>
          <li>
            <strong>Approximate Location:</strong> General location derived from
            your IP address solely for analytics and regional ad relevance (we
            do NOT request or access an exact GPS location).
          </li>
        </ul>

        <h2>4. Third-Party Services</h2>
        <p>
          We use trusted third-party services that may collect information to
          provide analytics and serve advertisements.{" "}
          <em>
            These services cannot, and do not, access your images or PDF files:
          </em>
        </p>
        <ul>
          <li>
            <strong>Google Analytics (Firebase):</strong> Used to collect crash
            reports and anonymous usage data to help us understand how the
            Application performs.
          </li>
          <li>
            <strong>Google AdMob:</strong> Integrated to display targeted
            advertisements. AdMob may collect your Advertising ID and
            interaction data.
          </li>
        </ul>

        <h2>5. How We Use the Information</h2>
        <p>
          The automatically collected technical data is used exclusively to:
        </p>
        <ul>
          <li>Operate, maintain, and improve the Application's stability.</li>
          <li>
            Serve relevant advertisements to support the development of the app.
          </li>
          <li>
            Analyze user trends to introduce new features (like PDF compression
            and merging).
          </li>
        </ul>

        <h2>6. Data Security</h2>
        <p>
          We implement commercially reasonable security measures to protect your
          data. Since all document processing is done locally, the risk of your
          sensitive documents being intercepted by our systems is non-existent.
        </p>

        <h2>7. Your Choices & Opt-Out</h2>
        <p>
          You have control over your data and how it is shared with ad networks:
        </p>
        <ul>
          <li>
            <strong>Opt-out of Personalized Ads:</strong> You can opt-out of
            personalized advertising via your Android Device Settings (Settings
            &gt; Google &gt; Ads &gt; Opt out of Ads Personalization) or by
            visiting{" "}
            <a
              href="https://adssettings.google.com/"
              target="_blank"
              rel="noreferrer"
            >
              Google Ad Settings
            </a>
            .
          </li>
          <li>
            <strong>Revoke Permissions:</strong> You can revoke Camera and
            Storage permissions at any time through your device settings, though
            this will limit the app's functionality.
          </li>
        </ul>

        <h2>8. Children's Privacy</h2>
        <p>
          Our Application is not directed at children under the age of 13. We do
          not knowingly collect personal information from children. If we
          discover that data has been collected from a child under 13
          inadvertently through a third-party service, we will take steps to
          ensure it is deleted.
        </p>

        <h2>9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically to reflect changes in
          our practices or regulatory requirements. We encourage you to review
          this page occasionally. Your continued use of the Application after
          changes are posted constitutes your acceptance of the new policy.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          If you have any questions, concerns, or feedback regarding this
          Privacy Policy or our data practices, please contact us at:
        </p>
        <ContactSpin />
      </main>
    </div>
  );
};

export default ImageToPdfPrivacyPolicy;
